import { createMuiTheme } from '@material-ui/core/styles';
import cardSvg from '../assets/card.svg';
import close from '../assets/close.svg';
import font from '../assets/fonts/Gotham-Black.css';
import ptsansBook from '../assets/fonts/PTSans.css';
import ptsansBold from '../assets/fonts/PTSans-Bold.css';
import fontbook from '../assets/fonts/GothamHTF-Book.css';
import program from '../assets/program.png';


export const COLORS = {
  orange: '#F85C5C',
  darkOrange: '#cc4b4b',
  brightOrange: '#FF5722',
  grey: '#5d5d5d',
  green: '#00A37E',
  pink: '#FFB7C0',
  darkGreen: '#38A18A',
  lightGrey: '#9E9E9E',
  darkGrey: '#4A4A4A',
  borderColor: '#CDCDCD',
  white: '#FFFFFF',
  black:'#000000',
  gradient: 'linear-gradient(-128deg, #50E3C2 0%, #0BDFE8 40%, #00CB9D 100%)',
  yellow: '#FDC92F',
  blackTransparent: 'rgba(0,0,0,0.4)',
  redesignGreen: '#0FAB88',
  redesignHoverGreen: '#0b8267',
  red: '#CC0000',
  cornerstoneRed: '#8a272a',
  cornerstoneDarkRed: '#6c0a0d'
};





export const ChartColors = [
  {
    colors: [
      '#00A37E',
      '#5d5d5d',
      '#FDC92F',
      '#e96556',
      '#8b0927',
      '#3f3965',
      '#d2234c',
      '#b2bfc9',
    ],
  },
  {
    colors: [
      '#00A37E',
      '#5d5d5d',
      '#FDC92F',
      '#e96556',
      '#8b0927',
      '#3f3965',
      '#d2234c',
      '#b2bfc9',
    ],
  },
  {
    colors: [
      '#00A37E',
      '#5d5d5d',
      '#FDC92F',
      '#e96556',
      '#8b0927',
      '#3f3965',
      '#d2234c',
      '#b2bfc9',
    ],
  },
  {
    colors: [
      '#00A37E',
      '#5d5d5d',
      '#FDC92F',
      '#e96556',
      '#8b0927',
      '#3f3965',
      '#d2234c',
      '#b2bfc9',
    ],
  },
];

export const theme = createMuiTheme({
  palette: {
    type: 'dark', // @ToDO switching themes
    primary: {
      main: COLORS.white,
    },
    secondary: {
      main: COLORS.red,
    },
    error: {
      main: COLORS.orange,
    },
  },
  typography: {
    body1: {
      color: '#FormControlLabel',
      fontWeight: 400,
      lineHeight:'1em',
    },
  },
});

export const commonStyles = {
  itemName:{
    color: '#b0b0b0'
  },
  logoLong:{
    width: 45
  },
  mainBackground: {
    height: 'calc(100% - 40px)',
    maxWidth: '1200px',
    margin: '0 auto',
    padding:'10 10 10 0'
  },
  dialogTitle:{
    backgroundColor: '#8a272a',
    borderRadius: 0,
    padding:20,
    textTransform: 'uppercase'
  },
  dialogSub:{
    textTransform: 'none !important',
    fontWeight: 'normal',
    fontSize: 17,
    margin: 0,
    padding: '10px 0 0',
  },
  dialogCopy:{
    fontSize: '0.75em',
    fontWeight: 400,
    lineHeight: '1.5em',
    width: '80%',
    float: 'left',
  },
  dialogOddCopy:{
    fontSize: '0.75em',
    fontWeight: 400,
    lineHeight: '1.5em',
    width: '70%',
    float: 'left',
    paddingLeft: 15
  },
  doneBtn:{
    backgroundColor:'#91d028',
    color: '#fedede',
    minWidth:50,
    height:50,
    borderRadius: 50
  },
  dialogActions:{
    alignItems: 'center',
    justifyContent: 'center',
    height: 'auto',
    bottom: 10,
    verticalAlign: 'middle',
    position: 'absolute',
    right: 10
  },
  dialogContent:{
    padding:0,
    maxHeight:300
  },
  avatarHolder:{
    position:'absolute', 
    top: -45,
    left: '45%'
  },
  dialogPaper:{
    overflow:'visible',
    maxHeight:400
  },
  MuiDialogPaper:{
    overflow: 'initial'
  },
  avatarMain:{
    width:80,
    height:80
  },
  clearBoth:{
    clear:'both'
  },
  dialogIconBg:{
    height:50,
    width:50,
    borderRadius: 50,
    float:'left',
    paddingRight: 20
  },
  dialogIcon:{
    color: '#a8cdfd',
    paddingTop:15,
    textAlign: 'center'
  },
  dialogBtn:{
    fontSize:'0.7em',
    width:80,
    padding:5,
    backgroundColor: '#ffffff',
    boxShadow:'2px 2px 2px 0px rgba(0,0,0,0.15)',
    minHeight: 'auto',
    float:'right',
    borderRadius:0,
    color: '#000000',
    '&:hover': {
      backgroundColor: '#fedddd',
    },
  },
  dialogGreyBg:{
    marginTop: 5,
    backgroundColor: '#f6f6f6',
    color: '#B3B3B3',
    padding: 15,
    minHeight: 70,
    position:'relative'
  },
  dialogPinkBg:{
    marginTop: 5,
    backgroundColor: '#fedddd',
    color: '#000000',
    padding: 15,
    minHeight: 70,
    position:'relative'
  },
  dialogBlueBg:{
    marginTop: 5,
    backgroundColor: '#ddebfe',
    color: '#000000',
    padding: 15,
    minHeight: 70,
    position:'relative'
  },
  dialogYellowBg:{
    marginTop: 5,
    backgroundColor: '#fedab7',
    color: '#000000',
    padding: 15,
    minHeight: 70,
    position:'relative'
  },
  mainWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    margin: 'auto',
    height:'100%'
  },
  // ___________________________________________BUTTONS
  defaultButton: {
    backgroundColor: COLORS.cornerstoneRed,
    color: '#fff',
    boxShadow: 'none',
    boxSizing: 'border-box',
    height: 30,
    borderRadius: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    '&:hover': {
      backgroundColor: COLORS.cornerstoneDarkRed,
    },
    '&:active': {
      boxShadow: '0 1px 12px 7px rgba(0,0,0,0.5) inset',
    },
  },
  greyButton: {
    backgroundColor: COLORS.lightGrey,
    color: '#000',
    fontFamily: 'Gotham-Black',
    boxShadow: 'none',
    boxSizing: 'border-box',
    height: 30,
    borderRadius: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    '&:hover': {
      backgroundColor: COLORS.darkGrey,
    },
    '&:active': {
      boxShadow: '0 1px 12px 7px rgba(0,0,0,0.5) inset',
    },
  },
  select:{
    paddingTop: 18,
    outline:0,
    width:'100%',
    fontSize: 14,

  },
  orangeButton: {
    background: COLORS.orange,
    color: '#000',
    boxSizing: 'border-box',
    borderRadius: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
    textTransform: 'uppercase',
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 24,
    paddingRight: 24,
    '&:hover': {
      backgroundColor: COLORS.darkOrange,
    },
    '&:active': {
      boxShadow: '0 1px 12px 7px rgba(0,0,0,0.5) inset',
    },
  },
  wideButton: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 4,
    width: 205,
    height: 36,
  },
  transparentButton: {
    backgroundColor: 'transparent',
    border: `2px solid ${COLORS.cornerstoneRed}`,
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    fontSize: 12,
    height: 30,
    '&:hover': {
      backgroundColor: COLORS.cornerstoneDarkRed,
    },
  },
  shortButton: {
    width: 130,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 4,
  },
  // ___________________________________________BUTTONS
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  app: {
    textAlign: 'center',
   
  },
  appBarHeader: {
    boxShadow: 'none',
  },
  // ___________________________________________POPUP
  popup: {
    backgroundColor: 'rgba(255,255,255,1)',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: theme.zIndex.appBar + 2,
  },
  popupNormal: {
    backgroundColor: 'rgba(255,255,255,.7)',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: theme.zIndex.appBar + 2,
  },
  loginPopup: {
    backgroundColor: 'transparent',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: theme.zIndex.appBar + 2,
  },
  popupHeaderTextLogin: {
    fontSize: 22,
    textTransform: 'uppercase',
    color: '#000',
    margin: '0 0 0 10px',
  },
  popupHeaderLogin: {
    backgroundImage: COLORS.gradient,
    padding: '20px 10px 20px 20px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  popupTitle:{
    padding: '10px',
  },
  popupTitleIcon:{
    fontSize: '3rem'
  },
  popupContent: {
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    background: '#fff',
    width: 350,
    zIndex: 10,
  },
  popupCopy:{
    width:'100%',
    backgroundColor: '#961B26',
    padding:'15px',
    fontSize:'1rem',
    color: '#ffffff',
    fontFamily: 'PTSans-Bold',
    textAlign: 'left'
  },
  popupHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  closePopup: {
    color: '#000',
    background: 'transparent',
    alignSelf: 'flex-end',
    cursor: 'pointer',
  },
  popupHeaderText: {
    fontSize: 14,
    color: '#000',
    margin: 0
  },
  popupBody: {
    position: 'relative',
  },
  popupBodyThinkTool: {
    background: '#000',
    padding: '35px 40px 25px 40px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  popupIframe: {
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    width: 960,
    height: 'auto',
    position: 'relative',
    zIndex: 10,
  },
  popupWrapper: {
    backgroundColor: 'transparent',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: theme.zIndex.appBar + 2,
  },
  popupContainer: {
    background: '#FFFFFF',
    width: '100%',

    zIndex: 10,
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
  leftSide: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: 40,
  },
  rightSide: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItem: 'center',
    justifyContent: 'center',
    padding: 40,
    position:'relative',
    overflow:'scroll'
    
  },
  topPart: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  topPart2: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  bottomLeftText: {
    fontSize: 36,
    lineHeight: '42px',
    color: '#000',
    textAlign: 'center',
    fontWeight: 400,
    margin: 0,
  },
  logoPopup: {
    // flex: 1,
    // position: 'static',
  },
  popupSubtitle: {
    fontSize: 18,
    lineHeight: '21px',
    color: '#000',
    marginBottom: 14,
    textAlign: 'center',
  },
  forgotLink: {
    textAlign: 'center',
    cursor: 'pointer',
  },
  forgotLinkText: {
    color: COLORS.cornerstoneRed,
    fontSize: 14,
  },
  registrationCaption: {
    color: '#000',
    fontSize: 14,
    lineHeight: '42px',
  },
  registrationLink: {
    color: COLORS.cornerstoneRed,
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    fontWeight: 400,
  },
  // ___________________________________________POPUP
  notification: {
    backgroundColor: COLORS.redesignGreen,
    position: 'absolute',
    marginLeft: 'auto',
    marginRight: 'auto',
    top: 0,
    left: 0,
    right: 0,
    height: 45,
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: theme.zIndex.appBar + 2,
    cursor: 'pointer',
    border: 0,
  },
  tabWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    overflowY: 'auto',
    height: 'calc(100% - 270px)',
  },
  tabSelected: {
    background: '#000',
  },
  noIndicator: {
    display: 'none',
  },
  formPopup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 10,
    marginBottom: 30,
  },
  // ___________________________________________FORM
  formInput: {
    border: `1px solid ${COLORS.lightGrey}`,
    padding: 5,
    fontSize: 14,
    fontWeight: 400,
    color:COLORS.lightGrey
  },
  formInputFocus: {
    borderColor: COLORS.cornerstoneRed,
  },
  formInputLabel: {
    color: '#000',
    fontSize: 14,
    fontWeight: 400,
    marginBottom: 5,
    paddingBottom:5
  },
  errorBottomText: {
    marginTop: -5,
    color: COLORS.orange,
  },
  inputError: {
    borderColor: COLORS.orange,
  },

  formField: {
    width: '100%',
  },
  regField: {
    marginBottom: theme.spacing.unit * 2.6,
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      marginBottom: 15,
    },
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
    width: '100%',
  },
  formLinks: {
    fontSize: 12,
    color: 'rgba(0,0,0,0.54)',
    textAlign: 'center',
    lineHeight: 16,
    textDecoration: 'none',
    display: 'block',
    marginBottom: theme.spacing.unit,
  },
  formError: {
    position: 'relative',
    width: '100%',
    top: 0,
    left: 0,
    right: 0,
    background: COLORS.cornerstoneRed,
    color: '#000',
    textAlign: 'center',
    padding: '5px 0',
    margin: '10px 0 ',
  },
  formSuccess: {
    position: 'relative',
    width: '100%',
    top: 0,
    left: 0,
    right: 0,
    background: '#0FAB88',
    color: '#000',
    textAlign: 'center',
    padding: '5px 0',
    margin: '10px 0',
    fontWeight: 400,
  },
  a: {
    textDecoration: 'none',
  },
  buttonWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  // ___________________________________________FORM
  // ___________________________________________CARD
  card: {
    width: '100%',
    height: 295,
    padding:5,
    margin: theme.spacing.unit,
    background: `url(${cardSvg}) 0 no-repeat`,
    backgroundSize: 'cover',
    boxShadow: 'none',
    padding: theme.spacing.unit,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius:0
  },
  moduleCard: {
    width: 227,
    height: 295,
    margin: theme.spacing.unit,
    background: `url(${cardSvg}) 0 no-repeat`,
    backgroundSize: 'cover',
    boxShadow: 'none',
    padding: theme.spacing.unit,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  programCard: {
    width: 227,
    height: 295,
    margin: theme.spacing.unit,
    backgroundColor: "#CCCCCC",
    boxShadow: 'none',
    padding: theme.spacing.unit,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardContent: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 3}px`,
  },
  cardTitle: {
    fontSize: theme.typography.fontSize * 1.5,
    height: 55,
    overflow: 'hidden',
    marginTop: theme.spacing.unit,
    fontFamily: 'Gotham-Black'
  },
  assessmentTitle: {
    fontSize:12,
    marginTop: theme.spacing.unit,
    fontFamily: 'Gotham-Black',
    position:'absolute',
    padding:5,
    top:26,
    color:COLORS.white,
    textShadow: '1px 1px 3px #000'
  },
  dueDate: {
    fontSize: theme.typography.fontSize*0.8,
    height: 14,
    overflow: 'hidden',
    fontFamily: 'Gotham-Black',
    position:'absolute',
    color: COLORS.cornerstoneRed,
    right:5,
    lineHeight: '20px',
  },
  attemptsNumber: {
    fontSize: theme.typography.fontSize*0.8,
    height: 14,
    overflow: 'hidden',
    fontFamily: 'Gotham-Black',
    position:'absolute',
    color: COLORS.cornerstoneRed,
    left:5,
    lineHeight: '20px',
  },
  kambamTitle: {
    fontSize: theme.typography.fontSize,
    height: 18,
    overflow: 'hidden',
    fontFamily: 'Gotham-Black',
    color: COLORS.white,
    justify:'center',
    align:'center',
    padding:7

  },
  cardTitleHeadline: {
    fontSize: theme.typography.fontSize * 1.5,
  },
  progress: {
    background: COLORS.cornerstoneRed,
    height: 2,
  },
  percentage: {
    color: '#4A4A4A',
    fontSize: theme.typography.fontSize + 4,
    fontWeight: 400,
    height: 24,
    textAlign: 'center',
  },
  percentageSub: {
    color: '#4A4A4A',
    textTransform: 'uppercase',
    fontSize: theme.typography.fontSize - 5,
    fontWeight: 400,
  },
  mailsNumber: {
    borderRadius: '50%',
    width: 15,
    height: 15,
    background: COLORS.yellow,
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#000',
    fontSize: 10,
    marginLeft: 5,
    position: 'relative',
    top: -7,
    right: 8,
  },
  programImage: {
    backgroundColor: 'transparent',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  programCard: {
    height: 412,
    fontFamily: 'Gotham-Black',
  },

  programCardImage: {
    
    height: 412,
  },
  programCardImageSelected: {
    
    height: 200,
  },

  // modules and programs
  disableButtonClass: {
    border: 0,
    borderColor: 'transparent',
    padding: 0,
    backgroundColor: 'transparent',
    textAlign: 'left',
    '&:focus': {
      outline: 'none',
    },
  },
  cardTitleModule: {
    color: '#cbcaca',
    fontFamily: 'Gotham-Black',
    fontSize: 18,
    lineHeight: '20px',
    marginTop: 15,
    marginBottom: 10,
  },
  progressModuleText: {
    color: COLORS.cornerstoneRed,
    fontFamily: 'Gotham-Black',
    fontSize: 14,
    lineHeight: '20px',
  },
  date: {
    color: '#b0b0b0',
    fontWeight: 400,
    fontSize: theme.typography.fontSize,
    lineHeight: '16px',
  },
  moduleProgress: {
    color: COLORS.cornerstoneRed,
    fontWeight: 400,
    fontSize: theme.typography.fontSize,
    lineHeight: '16px',
  },
  buttonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    padding: 0,
  },
  progressWrapper: {
    background: COLORS.lightGrey,
    display: 'flex',
    width: '100%',
    height: 2,
    borderRadius: 7,
    overflow: 'hidden',
  },
  fileWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  selectedCard: {
    backgroundColor: '#292929',
    height: 240,
    '&:before': {
      content: 'close-quote',
      position: 'absolute',
      right: -17
    },
  },
  selectedModuleCard: {
    backgroundColor: '#292929',
    height: 240,
    width: 220,
    '&:before': {
      content: 'close-quote',
      position: 'absolute',
      right: -17
    },
  },
  selectedProgramCard: {
    backgroundColor: '#292929',
    height: 412,
    width: 265,
    '&:before': {
      content: 'close-quote',
      position: 'absolute',
      right: -17
    },
  },

  // ___________________________________________CARD
  // ___________________________________________THINKTOOL
  thinkToolWrapper: {
    height: 'calc(100%)',
  },
  thinkTool: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  // ___________________________________________THINKTOOL
  // ___________________________________________IFRAME
  iframe: {
    width: '100%',
    height: '100%',
  },
  carouselControlsCard: {
    backgroundColor: 'rgba(151,151,151,0.5)',
    color: COLORS.cornerstoneRed,
    textAlign: 'center',
    cursor: 'pointer',
  },
  contentHolder: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start'

		
  },
  assignmentHolder: {
    position:'absolute',
    top:46,
    left:0,
    bottom:60,
    height:'calc(100% - 60px)',
    width:'100%'
    
  },
  // ___________________________________________IFRAME

  // ___________________________________________USER/TL MAIN SCREEN
  userListWrapper: {
    height: 'calc(100%)',
    overflow: 'auto',
    display: 'inline-block',
    minWidth: 190,
  },
  toolsColumnWrapper: {
    height: 'calc(100% - 10px)',
    overflow: 'auto',
    display: 'inline-block',
    minWidth: 200,
  },
  dashboardWrapper: {
    height: 'calc(100%)',
    overflow: 'auto',
    display: 'inline-block',
    width: '100%',
    margin: '5px 5px -9px 0px'
  },
  columnHeader: {
    paddingTop: 20,
    paddingBottom: 0,
    fontSize: 13,
    color: '#000',
    fontFamily: 'Roboto',
    fontWeight: 400,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#eeeeee',
    marginBottom: 0,
    borderBottom: '2px solid #e6e6e6'
  },
  dashboardHeader: {
    justifyContent: 'flex-start',
    flex: 5,
  },
  userListHeader: {
    flex: 1,
    justifyContent: 'flex-start',
    minWidth: 196,
    paddingRight: 15,
    paddingLeft: 10,
  },
  toolsHeader: {
    flex: 1,
    justifyContent: 'flex-start',
    minWidth: 206,
    paddingRight: 35,
  },

  slimColumnHeader: {
    width: 205,
    textAlign:'left',
    justifyContent: 'flex-end',
    boxSizing: 'border-box',
    fontFamily: 'Gotham-Black',
    color: COLORS.black,
    padding: 10,
    margin:0
  },
  
    contentHeader: {
    flex: 1,
    justifyContent: 'flex-start',
    padding: 10,
    margin:0,
    color: COLORS.lightGrey,
    fontFamily: 'Gotham-Black',
  },

  headers: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  // ___________________________________________USER/TL MAIN SCREEN

  // ___________________________________________COMMON FOR MESSAGE
  messagesListWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  messageItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    fontFamily: 'Roboto',
    background: '#fff',
    boxShadow: '0 1px 4px 0 rgba(207,207,207,0.8)',
    cursor: 'pointer',
    flexShrink: 0,
  },
  messageRead: {
    background: 'none',
  },
  messageSelected: {
    boxShadow: `inset 0 0 0 2px ${COLORS.cornerstoneRed}`,
  },
  contentWrapper: {
    width: '100%',
    position: 'relative'
  },
  messageHeader: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
  },
  senderName: {
    color: '#000',
    fontSize: 12,
    fontWeight: 500,
  },
  messageTime: {
    color: COLORS.lightGrey,
    fontSize: 12,
    fontWeight: 500,
  },
  messageListSubject: {
    fontSize: 14,
    color: '#4a4a4a',
    fontWeight: 900,
    marginTop: 7,
    marginBottom: 7,
    fontFamily: 'Gotham-Black'
  },
  messageListContent: {
    color: COLORS.lightGrey,
    fontSize: 12,
    fontWeight: 500,
  },
  avatarWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },

  deleteIcon: {
    color: '#961B26',
  },
  deleteButton: {
    width: 24,
    height: 24,
  },
  dateSent: {
    color: '#B0B0B0',
    fontSize: 10,
  },
  messageSubject: {
    color: COLORS.darkGrey,
    fontSize: 18,
    marginBottom: 25,
    marginTop: 16,
    fontWeight: 400,
    fontFamily: 'Gotham-Black'
  },
  messageContent: {
    color: '#000',
    fontSize: 14,
    lineHeight: '24px',
    marginBottom: 10,
    flexGrow: 1,
    fontWeight: 400,
  },
  messageWrapper: {
    marginBottom: 'auto',
    minHeight: 230,
  },
  messageContentIcon: {
    margin: '0 auto 20px',
    display: 'block',
  },
  messageContentButtons: {
    display: 'flex',
    justifyContent: 'center',
    padding: '15px 0',
  },
  messageContentButton: {
    width: 100,
    margin: '0 15px',
  },
  messageInvitationText: {
    textAlign: 'center',
    padding: '0 20px',
  },
  messageInvitationStatus: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginTop: 25,
  },
  messageInvitationStatusIcon: {
    marginRight: 10,
  },
  messageInvitationStatusText: {
    fontSize: 16,
    margin: 0,
  },
  divider: {
    backgroundColor: COLORS.lightGrey,
  },
  attachInfo: {
    fontSize: 12,
  },
  attachInfoSize: {
    fontSize: 12,
    color: COLORS.cornerstoneRed,
  },
  attachNameSizeWrap: {
    display: 'flex',
    flexDirection: 'column',
  },
  close: {
    background: `url(${close}) no-repeat`,
    width: 17,
    height: 17,
    cursor: 'pointer',
  },
  messageTitle: {
    textTransform: 'uppercase',
    fontSize: 14,
    color: '#000',
    fontWeight: 400,
  },
  letterAttachments: {
    width: '100%',
    maxWidth: 400,
  },
  attachmentItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  attachmentType: {
    width: 40,
    height: 34,
    borderRadius: 2,
    background: '#17A2B8',
    color: '#ffffff',
    fontSize: 10,
    textTransform: 'uppercase',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    padding: 2,
    marginRight: 10,
  },
  // ___________________________________________COMMON FOR MESSAGE

  // ___________________________________________COMMON FOR REPORT
  centerReport: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 26,
    marginBottom: 15,
  },
  reportBox: {
    display: 'flex',
    paddingTop: 5,
    boxSizing: 'border-box',
    flex: 1,
    flexDirection: 'column',
  },
  reportCenteredBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  reportTitle: {
    fontSize: 14,
    fontFamily: 'Roboto',
    fontWeight: 300,
    marginTop: 0,
    color: '#000',
  },
  noMarginLeft: {
    fontSize: 36,
    fontFamily: 'Roboto',
    color: '#000',
    lineHeight: 1,
    fontWeight: 300,
    marginLeft: 0,
    marginRight: 5,
  },
  bigNumber: {
    fontSize: 36,
    fontFamily: 'Roboto',
    color: '#000',
    lineHeight: 1,
    fontWeight: 300,
    marginLeft: 12,
  },
  bigNumberWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
  },
  interactionWrapper: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'stretch',
  },
  interactionItem: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    borderRight: '1px solid rgba(255,255,255,0.2)',
  },
  interactionItemInner: {
    paddingRight: 15,
    position: 'relative',
    fontFamily: 'Roboto',
    marginLeft: 30,
  },
  weekDot: {
    position: 'absolute',
    top: 21,
    left: -10,
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#C04DD8',
  },
  interactionName: {
    display: 'block',
    color: '#000',
    fontSize: 10,
    fontWeight: 300,
    marginBottom: 12,
    marginTop: 5,
    marginLeft: 12,
  },
  interactionMarker: {
    display: 'block',
    width: 80,
    height: 3,
    background: '#E9E9E9',
    marginLeft: 12,
  },
  weekMarker: {
    display: 'block',
    width: '70%',
    height: '100%',
    background: '#C04DD8',
  },
  monthDot: {
    position: 'absolute',
    top: 21,
    left: -10,
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#F0C757',
  },
  monthMarker: {
    display: 'block',
    width: '70%',
    height: '100%',
    background: '#F0C757',
  },
  yearDot: {
    position: 'absolute',
    top: 21,
    left: -10,
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#4A90E2',
  },
  yearMarker: {
    display: 'block',
    width: '70%',
    height: '100%',
    background: '#4A90E2',
  },
  // ___________________________________________COMMON FOR REPORT

  // ___________________________________________COMMON FOR VERSIONS
  buttonVersions: {
    width: 100,
  },
  versionItem: {
    width: '100%',
    minHeight: 40,
    textAlign: 'left',
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: 'Roboto',
    paddingTop: 5,
    paddingBottom: 16,
    borderBottom: '1px solid #B0B0B0',
  },
  itemLeft: {
    flex: 4,
  },
  itemRight: {
    flex: 4,
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    position: 'relative',
  },
  itemPercentage: {
    flex: 1,
    fontSize: 24,
    color: '#000',
    fontWeight: 300,
  },
  versionName: {
    fontSize: 16,
    marginTop: 0,
    marginBottom: 0,
    color: '#000',
  },
  versionDate: {
    fontSize: 14,
    color: '#B0B0B0',
    fontWeight: 300,
  },
  itemIcon: {
    fontSize: 16,
    color: '#B0B0B0',
    transform: 'rotate(120deg) scale(1, -1)',
    marginBottom: 2,
    marginRight: 5,
    verticalAlign: 'middle',
  },
  itemLink: {
    marginRight: 37,
    position: 'relative',
    cursor: 'pointer',
  },
  // ___________________________________________COMMON FOR VERSIONS
};



// WEBPACK FOOTER //
// ./src/styles/styles.js